import { ChangeDetectionStrategy, Component, Input, ViewChild, ViewContainerRef } from '@angular/core';
import { BaseComponent } from '../../../core/layout/components/abstracts/base.component';

@Component({
  selector: 'app-form-control',
  templateUrl: './form-control.component.html',
  styleUrls: ['./form-control.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FormControlComponent extends BaseComponent {

  @ViewChild('errorContainer', { read: ViewContainerRef }) errorContainerRef: ViewContainerRef;

  @Input() label: string;
  @Input() icon: string;

  @Input() hasUnderline = false;
  @Input() isRequired = false;
  @Input() hasErrors = false;
  @Input() hasWarnings = false;
  @Input() showErrorIcon = true;
  @Input() isDisabled = false;
  @Input() isLabelInvisible = false;

  public disable(): void {
    this.isDisabled = true;
    this.cdr.detectChanges();
  }

  public enable(): void {
    this.isDisabled = false;
    this.cdr.detectChanges();
  }
}
